import *
    as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useHistory, useLocation } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Input, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import * as ServiceContactEntryStore from '../../store/ServiceContactEntry';
import * as ServiceContactMds from '../../models/ServiceContactModel';
import '../../../node_modules/cleave.js/dist/addons/cleave-phone.us'
const Cleave = require('../../../node_modules/cleave.js/react');

//const Cleave = require('../../../node_modules/cleave.js/dist/addons/cleave-phone.us');

type MyProps =
    { SessionState: SessionMdl.SessionModel, ServiceContact: ServiceContactMds.ServiceContactModel } & typeof ServiceContactEntryStore.actionCreators;

const CustomerRequest: React.FunctionComponent<MyProps> = (props: MyProps) => {

    const history= useHistory();

    const location = useLocation();
    
    useEffect(() => {            
        console.log({ ...ServiceContactMds.initialState, ...location.state });
        if (props.ServiceContact.success == 'Y') {
            //history.replace("Contacts");
            history.goBack();
            props.resetState();
        }
        if (props.ServiceContact.error) {
            alert(props.ServiceContact.error);
        }
    }, [props]);

    const [ContactInfoLocal, updateContactInfo] = useState<ServiceContactMds.ServiceContactModel>({ ...ServiceContactMds.initialState, ...location.state });

    const SubmitEvent = (e: React.FormEvent) => {
        console.log(ContactInfoLocal);
        e.preventDefault();
        props.updateCustomer(ContactInfoLocal);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.value };
        updateContactInfo({ ...ContactInfoLocal, ...valueChanged });
    }

    const handleCleveChange = (e: any) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.rawValue };
        updateContactInfo({ ...ContactInfoLocal, ...valueChanged });

    }

    const RequestBtn = () => {
        if (!props.ServiceContact.processing) {
            return (<input type="submit" onClick={SubmitEvent} value="Submit" className="btn btn-success" id="RequestBtn" name="RequestBtn" />);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.ServiceContact.processing} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            {
                <Card>
                    <CardBody>
                        <Row>
                            <Col xs={12}>                                
                                <SaLabel Text={"Contact Name"} />
                                <input type="text" onChange={handleChange} className="form-control" key="contactName" id="contactName" name="contactName" value={ContactInfoLocal.contactName} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Phone Home"} />
                                {/*<input type="text" onChange={handleChange} className="form-control" key="phoneNumber" id="phoneNumber" name="phoneNumber" value={ContactInfoLocal.phoneNumber} />*/}
    
                                <Cleave                                    
                                    options={{
                                        uppercase: true,
                                        //delimiters: [' ', ' '],
                                        blocks: [3, 3, 4],
                                        numericOnly: true
                                    }} className="form-control"
                                    onChange={handleCleveChange}
                                    key="phoneNumber" id="phoneNumber" name="phoneNumber"
                                    value={ContactInfoLocal.phoneNumber}
                                />

                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Work Phone"} />
                                {/*<input type="text" onChange={handleChange} className="form-control" key="workPhoneNumber" id="workPhoneNumber" name="workPhoneNumber" value={ContactInfoLocal.workPhoneNumber} />*/}
                                <Cleave
                                    options={{
                                        uppercase: true,
                                        //delimiters: [' ', ' '],
                                        blocks: [3, 3, 4],
                                        numericOnly: true
                                    }} className="form-control"
                                    onChange={handleCleveChange}
                                    key="workPhoneNumber" id="workPhoneNumber" name="workPhoneNumber"
                                    value={ContactInfoLocal.workPhoneNumber}
                                />
                            </Col>
                        </Row>                       
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Ext"} />
                                <input type="text" onChange={handleChange} className="form-control" key="phoneExt" id="phoneExt" name="phoneExt" value={ContactInfoLocal.phoneExt} />
                            </Col>
                        </Row>    
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Personal Cell"} />
                                {/*<input type="text" onChange={handleChange} className="form-control" key="mobilNumber" id="mobilNumber" name="mobilNumber" value={ContactInfoLocal.mobilNumber} />*/}
                                <Cleave
                                    options={{
                                        uppercase: true,
                                        //delimiters: [' ', ' '],
                                        blocks: [3, 3, 4],
                                        numericOnly: true
                                    }} className="form-control"
                                    onChange={handleCleveChange}
                                    key="mobilNumber" id="mobilNumber" name="mobilNumber"
                                    value={ContactInfoLocal.mobilNumber}
                                 />
                            </Col>
                        </Row>                       
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Work Mobile"} />
                                {/*<input type="text" onChange={handleChange} className="form-control" key="workMobileNumber" id="workMobileNumber" name="workMobileNumber" value={ContactInfoLocal.workMobileNumber} />*/}
                                <Cleave
                                    options={{
                                        uppercase: true,
                                        //delimiters: [' ', ' '],
                                        blocks: [3, 3, 4],
                                        numericOnly: true
                                    }} className="form-control"
                                    onChange={handleCleveChange}
                                    key="workMobileNumber" id="workMobileNumber" name="workMobileNumber"
                                    value={ContactInfoLocal.workMobileNumber}
                                />
                            </Col>
                        </Row>                       
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Email"} />
                                <input type="text" onChange={handleChange} className="form-control" key="email" id="email" name="email" value={ContactInfoLocal.email} />
                            </Col>
                        </Row>                       
                        <Row>
                            <Col xs={12}>
                                <br />
                                <RequestBtn />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

            }
        </Container>
    );
}

export default connect((state: ApplicationState) =>
({
    ...{
        ServiceContact: state.serviceContactEntryState,
        SessionState: state.sessionState
    }
}),
    ServiceContactEntryStore.actionCreators)(CustomerRequest as any);